let selectedPinZIndex = 1000;

export function getSelectedPinZIndex() {
    return selectedPinZIndex;
}

export function incrementSelectedPinZIndex() {
    selectedPinZIndex++;
}

let mapDrawingState = false; //true when user drawing on the map

export function setMapDrawingState(state) {
    mapDrawingState = state;
}

export function getMapDrawingState() {
    return mapDrawingState;
}